import React from "react";
import { sCmpUserReportService } from "../../services/sCmpUserReportService";
import { InputDiv } from "../../assets/StyledComponent/Input/Input.Style";
import {
  getCmpFoodTotalExpenseDownloadService,
  getFoodCompanyExpenseService,
  getFoodTotalExpenseDownloadService,
  getFoodTotalExpenseService,
} from "../../services/cFoodExpenseReportService";
import { useStore } from "../../store";
import "../TotalExpenseReport/styles.css";
import {
  GET_CMP_USER_REPORT_FAILURE,
  GET_CMP_USER_REPORT_SUCCESS,
} from "../../container/SCmpUserReport/types";
import {
  GET_CFOOD_TOTAL_EXPENSE_REPORT,
  GET_CFOOD_TOTAL_EXPENSE_REPORT_FAILURE,
  SET_ALL_REPORT_BY_FALSE,
  SET_FROM_TIME,
  SET_REPORT_BY_ENGLISH_DATE,
  SET_TO_TIME,
  UNSET_REPORT_BY_ENGLISH_DATE,
} from "../../container/FoodReport/types";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
interface Iprops {
  companyId: string;
  reportType?: string;
}

const EnglishDateSelect = ({ companyId, reportType }: Iprops) => {
  const [state, dispatch]: any = useStore();
  const [date, setDate] = React.useState({ year: "", month: "" });
  const month = [
    {
      name: "January",
      value: "01",
    },
    {
      name: "February",
      value: "02",
    },
    {
      name: "March",
      value: "03",
    },
    {
      name: "April",
      value: "04",
    },
    {
      name: "May",
      value: "05",
    },
    {
      name: "June",
      value: "06",
    },
    {
      name: "July",
      value: "07",
    },
    {
      name: "August",
      value: "08",
    },
    {
      name: "September",
      value: "09",
    },
    {
      name: "October",
      value: "10",
    },
    {
      name: "November",
      value: "11",
    },
    {
      name: "December",
      value: "12",
    },
  ];

  const year = () => {
    let year = [];
    for (let i = 2022; i <= new Date().getFullYear(); i++) {
      year.push({ name: `${i}`, value: i });
    }
    return year;
  };

  const valueOfEye = state.foodReportReducer?.englishDate;

  const getTableData = async () => {
    const fromDate = date && `${date.year}-${date.month}-01`;
    const toDate = date && `${date.year}-0${parseInt(date.month) + 1}-01`;

    // console.log(fromDate, toDate);

    var d = new Date(toDate);
    d.setDate(d.getDate() - 1);
    const year = d.getFullYear().toString();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const to_date = year + "_" + month + "_" + day;
    if (companyId) {
      getCmpFoodTotalExpenseDownloadService(fromDate, to_date, companyId);
    } else getFoodTotalExpenseDownloadService(fromDate, to_date);
  };

  React.useEffect(() => {
    var today = new Date();
    var day = String(today.getDate()).padStart(2, "0");
    var month = String(today.getMonth() + 1).padStart(2, "0");
    var year = today.getFullYear().toString();

    setDate({ year, month });
  }, []);

  const handleFoodTotalExpense = () => {
    const fromDate = date && `${date.year}-${date.month}-01`;
    const toDate = date && `${date.year}-0${parseInt(date.month) + 1}-01`;

    // console.log("englishDateSelect", toDate);

    var d = new Date(toDate);
    d.setDate(d.getDate() - 1);
    const year = d.getFullYear().toString();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const to_date = year + "_" + month + "_" + day;

    dispatch({
      type: SET_REPORT_BY_ENGLISH_DATE,
    });

    valueOfEye === true &&
      dispatch({
        type: UNSET_REPORT_BY_ENGLISH_DATE,
      });
    dispatch({
      type: SET_FROM_TIME,
      fromDate: fromDate,
    });
    dispatch({
      type: SET_TO_TIME,
      toDate: to_date,
    });

    if (companyId) {
      if (reportType === "Food Report") {
        getFoodCompanyExpenseService(fromDate, to_date, companyId)
          .then((res: any) => {
            dispatch({
              type: GET_CFOOD_TOTAL_EXPENSE_REPORT,
              cTotalExpenseReport: res,
            });
          })
          .catch((err) => {
            dispatch({
              type: GET_CFOOD_TOTAL_EXPENSE_REPORT_FAILURE,
              cTotalExpenseReportError: err,
            });
          });
      } else {
        sCmpUserReportService(fromDate, to_date, companyId)
          .then((res: any) => {
            dispatch({
              type: GET_CMP_USER_REPORT_SUCCESS,
              SCmpUserReport: res,
            });
          })
          .catch((err) => {
            dispatch({
              type: GET_CMP_USER_REPORT_FAILURE,
              SCmpUserReportError: err,
            });
          });
      }
    } else
      getFoodTotalExpenseService(fromDate, to_date)
        .then((res: any) => {
          dispatch({
            type: GET_CFOOD_TOTAL_EXPENSE_REPORT,
            cTotalExpenseReport: res,
          });
        })
        .catch((err) => {
          dispatch({
            type: GET_CFOOD_TOTAL_EXPENSE_REPORT_FAILURE,
            cTotalExpenseReportError: err,
          });
        });
  };
  return (
    <InputDiv>
      <div
        className="w-80 pb-3 text-center rounded d-flex"
        style={
          {
            // width: "68.5%",
            // display: "flex",
            // flexDirection: "row",
            // justifyContent: "space-between",
          }
        }
      >
        <label
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            margin: "0px 21px",
            marginRight: "15px",
            fontWeight: "500",
          }}
        >
          Select English Year
        </label>
        <select
          style={{
            width: "8.75rem",
            padding: "0.5px 1px",

            borderRadius: "5px",
            background: "white",
          }}
          value={date.year}
          onChange={(e) => {
            dispatch({
              type: SET_ALL_REPORT_BY_FALSE,
            });
            setDate({ ...date, year: e.target.value });
          }}
        >
          {year().map((item) => (
            <option value={item.value} key={item.name}>
              {item.name}
            </option>
          ))}
        </select>
        <label
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            marginLeft: "32px",
            marginRight: "17px",
            fontWeight: "500",
          }}
        >
          Select English Month
        </label>
        <select
          style={{
            width: "8.75rem",
            padding: "0.5px 1px",
            borderRadius: "5px",
            background: "white",
          }}
          value={date.month}
          onChange={(e) => {
            dispatch({
              type: SET_ALL_REPORT_BY_FALSE,
            });
            setDate({ ...date, month: e.target.value });
          }}
        >
          {month.map((item) => (
            <option value={item.value} key={item.name}>
              {item.name}
            </option>
          ))}
        </select>

        {/* <button className="searchBtn" onClick={getTableData}>
          Download
        </button> */}
        <button
          className="searchBtn"
          type="button"
          style={{
            backgroundColor: valueOfEye ? "#e55607" : "#999",
          }}
          onClick={handleFoodTotalExpense}
        >
          {valueOfEye ? <AiFillEye /> : <AiFillEyeInvisible />}
        </button>
      </div>
    </InputDiv>
  );
};

export default EnglishDateSelect;
